<table data-automation-e2e-selector="economicEventValuesTable">
    <thead>
        <tr>
            <th></th>
            <th *ngFor="let column of columns | async">
                {{column}}
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let value of event.values">
            <td data-automation-e2e-selector="economicEventValueName">{{value.name}}</td>
            <td data-automation-e2e-selector="economicEventValue" *ngFor="let column of columns | async">
                {{formatValue(value, column)}}
            </td>
        </tr>
    </tbody>
</table>